import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { FaChevronDown } from 'react-icons/fa';
import { useTranslation } from 'react-i18next';

const FAQ = () => {
  const [activeIndex, setActiveIndex] = useState(null);
  const { t } = useTranslation();

  const toggleAccordion = (index) => {
    setActiveIndex(activeIndex === index ? null : index);
  };

  const formatAnswer = (text) => {
    return text.split('\\n').map((line, i) => (
      <React.Fragment key={i}>
        {line}
        <br />
      </React.Fragment>
    ));
  };

  const faqData = t('faq.questions', { returnObjects: true });

  return (
    <section className="faq-section">
      <motion.h2 
        className="section-title"
        initial={{ opacity: 0, y: 30 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, margin: "-50px" }}
        transition={{ duration: 1, ease: "easeOut" }}
      >
        {t('faq.title')}
      </motion.h2>
      
      <motion.div 
        className="section-subtitle"
        initial={{ opacity: 0, y: 20, scale: 0.95 }}
        whileInView={{ opacity: 1, y: 0, scale: 1 }}
        viewport={{ once: true, margin: "-50px" }}
        transition={{ duration: 1, delay: 0.3, ease: "easeOut" }}
      >
        <motion.p
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          transition={{ duration: 0.8, delay: 0.5 }}
        >
          {t('faq.description')}
        </motion.p>
      </motion.div>
      
      <div className="faq-container">
        {faqData.map((item, index) => (
          <motion.div 
            key={index}
            className={`faq-item ${activeIndex === index ? 'active' : ''}`}
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-50px" }}
            transition={{ duration: 0.5, delay: index * 0.1 }}
          >
            <div 
              className="faq-question"
              onClick={() => toggleAccordion(index)}
            >
              <span>{item.question}</span>
              <span className="icon"><FaChevronDown /></span>
            </div>
            <div className={`faq-answer ${activeIndex === index ? 'active' : ''}`}>
              {formatAnswer(item.answer)}
            </div>
          </motion.div>
        ))}
      </div>
    </section>
  );
};

export default FAQ; 